import CompetitionEdit from './CompetitionEdit';

export default CompetitionEdit;
